import { createContext, useContext, type ReactNode } from "react";
import type { DemoSample } from "./demo-sample";

const DemoAccountContext = createContext<DemoSample | null>(null);
export function DemoAccountProvider({ raw, children }: { raw: DemoSample; children: ReactNode }) {
  return <DemoAccountContext.Provider value={raw}>{children}</DemoAccountContext.Provider>;
}
export function useDemoAccount() { return useContext(DemoAccountContext); }
